export enum SortKeys {
  DateModified = "datemodified",
  Title = "title",
  Status = "status",
}
